// World 17 (Gale) — third post-launch expansion world. Wind cells nudge
// tiles by one cell when they land on the cell adjacent to a wind source.
//
// Different trigger geometry than W14 Ballast (gravity = tile-on-cell;
// wind = tile-adjacent-to-cell). Same post-slide push effect once
// triggered. Both share the engine's gravityLoop with its 6-step cycle
// guard — see slide.ts.
//
// Spec: docs/future/w15-w20-plan.md §1 W17.
//
// Progression (10 levels, d=3-8 band, all r=3 with 11-12 tiles):
//   L1: d=3 — gentle introduction; one wind cell nudges visible
//   L2: d=4 — wind starts mattering for placement
//   L3-L4: d=5 — wind composition with stoppers
//   L5-L6: d=6 — multi-step planning around wind
//   L7-L8: d=7 — denser color counts, wind extends key slides
//   L9-L10: d=8 — peak Gale: tight budgets where wind is the difference
//
// Generator: tools/generate-parallel.mjs --world 17 (4 configs across
// r=3 × tc=11-13 × c=4-5 × wc=1-2). Walltime ~2.3 hours per the high
// solver-truncation rate on wind-rich boards. Pool of 292 candidates
// curated to 10 via selectByBucket. r=4 configs were dropped during
// probe phase due to 87% solver truncation rate.
import type { LevelDef } from '@tessera/engine';
import { WORLD_17_GENERATED } from './world17-generated';

export const WORLD_17_LEVELS: LevelDef[] = [...WORLD_17_GENERATED];
